import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import { setupI18n } from "./i18n";
import en from "@/assets/i18n/en";
import fr from "@/assets/i18n/fr";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faExclamationCircle,
  faCheckCircle,
  faPlus,
  faInfo,
  faFile,
  faMapPin,
  faBan,
  faCalendarWeek,
  faFileUpload,
  faWallet,
  faLock,
  faEnvelope,
  faTasks,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

import "@/scss/index.scss";

library.add(
  faExclamationCircle,
  faCheckCircle,
  faPlus,
  faInfo,
  faFile,
  faMapPin,
  faBan,
  faCalendarWeek,
  faFileUpload,
  faWallet,
  faLock,
  faEnvelope,
  faTasks,
  faArrowRight
);

const i18nOptions = {
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  globalInjection: true,
  messages: {
    en,
    fr,
  },
};

/* eslint-disable @typescript-eslint/no-empty-function */
if (process.env.NODE_ENV === "production") {
  console.warn = function() {};
  console.error = function() {};
  console.log = function() {};
}

setupI18n(i18nOptions).then((i18n: any) => {
  createApp(App)
    .component("font-awesome-icon", FontAwesomeIcon)
    .use(i18n)
    .use(router)
    .mount("#app");
});
